import { Column } from '@app/modules/table/classes/column.class';
import { CellDisplay } from '@app/modules/table/enums/cell-display.enum';

export class FirstNameColumn extends Column {
    title = 'import.integrations.steps.connect.fieldTypes.names.first';
    property = 'firstName';
    type: CellDisplay = CellDisplay.string;
}

export class LastNameColumn extends Column {
    title = 'import.integrations.steps.connect.fieldTypes.names.last';
    property = 'lastName';
    type: CellDisplay = CellDisplay.string;
}

export class EmailColumn extends Column {
    title = 'import.integrations.steps.connect.fieldTypes.emails';
    property = 'email';
    type: CellDisplay = CellDisplay.string;
}

export class TitleColumn extends Column {
    title = 'import.integrations.steps.connect.fieldTypes.title';
    property = 'title';
    type: CellDisplay = CellDisplay.string;
}

export class DepartmentColumn extends Column {
    title = 'import.integrations.steps.connect.fieldTypes.department';
    property = 'department';
    type: CellDisplay = CellDisplay.string;
}

export class HiredAtColumn extends Column {
    title = 'import.integrations.steps.connect.fieldTypes.hired_at';
    property = 'hiredAt';
    type: CellDisplay = CellDisplay.date;
}

export class RolePermissionsColumn extends Column {
    title = 'import.integrations.steps.connect.fieldTypes.role_permissions';
    property = 'rolePermission';
    type: CellDisplay = CellDisplay.string;
}

export class EmploymentTypeColumn extends Column {
    title = 'import.integrations.steps.connect.fieldTypes.employment_type';
    property = 'employmentType';
    type: CellDisplay = CellDisplay.string;
}

export class OfficeNameColumn extends Column {
    title = 'import.integrations.steps.connect.fieldTypes.office_name';
    property = 'officeName';
    type: CellDisplay = CellDisplay.string;
}
